<template>
    <footer>
        <div class="social-media">
            <router-link class="router-link easeOutCubic" to="/our-projects">Our projects</router-link>
            <a href="https://www.instagram.com/the360.agency/" target="_blank"><i class="fab fa-instagram"></i></a>
        </div>
        <div :class="['form','slideInUp','animated','easeOutCubic',{'on' : contact}]">
            <i :class="['fas',{'fa-times' : contact, 'fa-envelope' : !contact},'bounceInUp','animated']" @click="openContact()"></i>
            <div :class="['content','bounceInUp','animated',{'hidden': response}]">
                <h2>How can we help you?</h2>
                <form id="form-360" v-on:submit.prevent>
                    <input name="name" type="text" placeholder="Your name..." v-model="name" required>
                    <input name="email" type="text" placeholder="@mail.com" v-model="email" required>
                    <input name="nelchavo" type="text" placeholder="Nel Chavo" v-model="nel">
                    <textarea name="message" placeholder="What do you need?" v-model="message" required></textarea>
                    <!-- <input type="submit" value="Send"> -->
                    <button class="easeOutCubic" @click="submitForm">Send<i class="fas fa-bolt"></i></button>
                </form>
            </div>
            <div :class="['response',{'hidden': !response}]">
                <i class="far fa-check-circle"></i>
                <h2>We will contact you soon.</h2>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            contact: false,
            name: null,
            email: null,
            message: null,
            nel: null,
            response: false
        }
    },
    methods: {
        openContact(){
            this.contact = !this.contact 
        },
        submitForm(){
            if(this.nel === null & this.name.length > 0 & this.email.length > 0 & this.message.length > 0){
                let form = document.getElementById("form-360");
                let dataForm = new FormData(form);
                fetch('submit_mail.php',{
                    method: 'POST',
                    body: dataForm
                })
                .then(data => data.json())
                .then(data =>{
                    if(data === "send") this.response = true
                })
            }
        }
    }
}
</script>